/* eslint-disable */
Number.prototype.formatFloat = function(c) {
  var n = this;
  var c = isNaN(c = Math.abs(c)) ? 2 : c;
  var d = '.';
  var t = ',';
  var s = n < 0 ? '-' : '';
  var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + '';
  var j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
};

window.convertToYearsMonths = function(months) {
  var y = Math.floor(months / 12);
  var m = months % 12;
  var year = y == 1 ? ' year ' : ' years ';
  var month = m == 1 ? ' month' : ' months';
  return y > 0 ? y + year + m + month : m + month;
};

window.Calculator = {};

Calculator.getMonthlyMortgagePayment = function(principal, numPayments, interest) {
  var P = principal;
  var i = interest;
  var n = numPayments;
  return i > 0 ? (i * P * Math.pow((1 + i), n)) / (Math.pow((1 + i), n) - 1) : P / n;
};

Calculator.getNumberOfPayments = function(monthlyPayment, principal, interest) {
  var A = monthlyPayment;
  var P = principal;
  var i = interest;

  return i > 0 ? (-(Math.log(1 - (P / A) * i)) / Math.log(1 + i)).toFixed(0) : (P / A).toFixed(0);
};

Calculator.getTotalPaid = function(monthlyPayment, numPayments) {
  return monthlyPayment * numPayments;
};

Calculator.getTotalInterestPaid = function(monthlyPayment, numPayments, principal) {
  var A = monthlyPayment;
  var n = numPayments;
  var P = principal;
  return A * n - P;
};

Calculator.getMonthlyTaxes = function(annualTax) {
  return annualTax / 12;
};

Calculator.getMonthlyInsurance = function(annualInsurance) {
  return annualInsurance / 12;
};

Calculator.getDownPaymentFromPercentage = function(purchasePrice, percentage) {
  return purchasePrice * (percentage / 100);
};

Calculator.getPiti = function(loanAmount, loanLength, interest, monthlyTax, monthlyInsurance) {
  var P = loanAmount;
  var n = loanLength * 12;
  var i = (interest / 100) / 12;
  var principalAndInterest = Calculator.getMonthlyMortgagePayment(P, n, i);
  // PITI = principal, interest, tax, insurance
  return principalAndInterest + monthlyInsurance + monthlyTax;
};

Calculator.getPitiByIncome = function(monthlyIncome, monthlyTotalDebt) {
  var p1 = monthlyIncome * 0.28;
  var p2 = (monthlyIncome * 0.36) - monthlyTotalDebt;
  return p1 <= p2 ? p1 : p2;
};

Calculator.getMonthlyRequiredIncome = function(piti, totalMonthlyLiabilities) {
  var r1 = piti / 0.28;
  var r2 = (piti + totalMonthlyLiabilities) / 0.36;
  return r1 >= r2 ? r1 : r2;
};

Calculator.getLoanAmount = function(piti, loanLength, interest) {
  var N = loanLength * 12;
  var i = (interest / 100) / 12;
  return (piti * (1 - Math.pow((1 + i), -N))) / i;
};
